import { useOutletContext } from "react-router";
import { useComparisonModeContext } from "@acto/taskpane/core/contexts/TenantSettingsContext";
import { Kpi } from "@acto/taskpane/core/domain";
import type { CustomerOutletContext } from "@acto/taskpane/field-sales-2/CustomerDetailsLayout";
import { type KpiTrend, useKpiTrend } from "@acto/taskpane/field-sales-2/data-access/useKpiTrend";

interface CustomerRevenueTrendOptions {
  clientId: string | undefined;
  kpi?: Kpi;
  productGroupId?: string;
}

export function useCustomerRevenueTrend({
  clientId,
  kpi = Kpi.REVENUE,
  productGroupId,
}: CustomerRevenueTrendOptions): KpiTrend {
  const { dateRange, isCustomRange } = useOutletContext<CustomerOutletContext>();
  const comparisonMode = useComparisonModeContext();
  return useKpiTrend(clientId, comparisonMode, kpi, dateRange, productGroupId, isCustomRange);
}
